import Swiper from "swiper";
import "swiper/css/scrollbar";
import { Navigation, Scrollbar } from "swiper/modules";
import { customFadeInTopElem } from "assets/animations";

const animateSlides = (items, parentElem) => {
	items?.forEach((item, index) => {
		if (!item.classList.contains("animated"))
			customFadeInTopElem({ elem: item, parentElem, index });
	});
};

const getVisibleSlides = (thisSwiper) => {
	const slidesInView = [];
	for (
		let i = thisSwiper.activeIndex;
		i < thisSwiper.activeIndex + thisSwiper.params.slidesPerView;
		i++
	) {
		if (thisSwiper.slides[i]) {
			if (!thisSwiper.slides[i]?.classList.contains("animated"))
				slidesInView.push(thisSwiper.slides[i]);
		}
	}

	return slidesInView;
};

export const swiperCreateNew = (sectionId) => {
	const thisSection = document.getElementById(sectionId);
	const swiperElem = thisSection?.querySelector(".swiper");
	const navLeft = thisSection?.querySelector(".swiper-navigation .nav-left");
	const navRight = thisSection?.querySelector(".swiper-navigation .nav-right");
	const scrollbar = thisSection?.querySelector(".swiper-scrollbar");

	const thisSwiper = new Swiper(swiperElem, {
		init: false,
		modules: [Navigation, Scrollbar],
		slidesPerView: 1.15,
		spaceBetween: 18,
		grabCursor: true,
		lazy: true,
		navigation: {
			nextEl: navRight,
			prevEl: navLeft,
		},
		scrollbar: {
			el: scrollbar,
			draggable: true,
		},
		breakpoints: {
			576: {
				slidesPerView: 1.8,
			},
		},
	});

	thisSwiper.on("init", (swiper) => {
		animateSlides(getVisibleSlides(swiper), thisSection);
	});

	thisSwiper.init();

	thisSwiper.on("slideChange", (swiper) => {
		animateSlides(getVisibleSlides(swiper), thisSection);
	});

	return thisSwiper;
};
